(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
var fade_in = require('./fade-in');

var blog = ( function( $ ) {

	var _init = function() {
		// _setup_infinite_scroll();

		$( document ).on( 'pageloaded', _page_loaded );
	};

	var _page_loaded = function( event, $html ) {
		fade_in.add_handlers( $html.find( '.fade-in' ) );
	};

	if ( $( 'body.blog' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

} ) ( jQuery );

module.exports = blog;
},{"./fade-in":4}],2:[function(require,module,exports){
var notices = require('./notices');

var cart = ( function( $ ) {

	var _init = function() {
		update();
		_setup_single_button();
	};

	var update = function() {
		var data = {
			action: 'cart_total',
			cart_total_nonce: ScriptData.cart_total_nonce
		};

		$.get( ScriptData.ajaxurl, data, _get_total_response );
	};

	var _get_total_response = function( response ) {
		if ( response.total === false ) {
			$( '.cart .total').html( '' );
		} else {
			$( '.cart .total').html( response.total );
		}
	};
	
	var _setup_single_button = function() {
		$( '.single-add-to-cart-button' ).on( 'click', function( event ) {
			var product_id = $( this ).data( 'product-id' );
			var variation_id = $( this ).data( 'variation-id' );

			add_item( product_id, 1, variation_id );

			$( this ).loading();

			event.preventDefault();
		});
	};
	
	var add_item = function( product_id, quantity, variation_id ) {
		variation_id = variation_id === undefined ? false : variation_id;
		
		var data = {
			action: 'cart_add_item',
			cart_add_item_nonce: ScriptData.cart_add_item_nonce,
			product_id: product_id,
			variation_id: variation_id,
			quantity: quantity
		};

		$.post(ScriptData.ajaxurl, data, function( response ) {
			if ( response ) {
				_added_item( response );
			}
		});
	};

	var _added_item = function( response ) {
		update();
		$( '.single-add-to-cart-button' ).loaded();
		$notices = $( response.notices );
		$( '.cart-messages' ).append( $notices );
		notices.timeout_fade( $notices );
	};

	$( document ).ready( _init );
	
	return {
		update: update	
	};

} ) ( jQuery );

module.exports = cart;
},{"./notices":14}],3:[function(require,module,exports){
var checkout = ( function( $ ) {

	var _init = function() {
		$( '#ship-to-different-address-checkbox').on( 'click', _toggle_shipping_fields );

		$( '#billing_postcode, #shipping_postcode' ).on( 'change keyup', _shipping_field_change );

		_update_quantities_events();
	};

	var _shipping_field_change = function( event ) {
		$( 'form.checkout' ).trigger( 'update' );
	};

	var _toggle_shipping_fields = function( event ) {
		$( '#shipping-address-accordion' ).collapse( 'toggle' );
	};

	var _update_quantities_events = function() {
		$( '#order-review .update-quantities').on( 'click', _update_quantities );
	};

	var _update_quantities = function() {
		var items = [];

		$( '#order-review tBody tr').each( function() {
			var cart_item_key = $( this ).data( 'cart-item-key' );
			var quantity = $( this ).find( '.quantity input' ).val();

			items.push( {
				cart_item_key: cart_item_key,
				quantity: quantity
			} );
		} );

		var data = {
			action: 'update_quantities',
			items: items,
			update_quantities_nonce: ScriptData.update_quantities_nonce
		};

		$.post( ScriptData.ajaxurl, data, _refresh_order_review );
	};

	var _refresh_order_review = function() {
		var data = {
			action: 'refresh_order_review',
			refresh_order_review_nonce: ScriptData.refresh_order_review_nonce
		};

		$( '#order-review' ).loading();

		$.get( ScriptData.ajaxurl, data, _order_review_response );
	};

	var _order_review_response = function( response ) {
		if ( response && response.table_html ) {
			var $container = $('#order-review').parent();
			$( '#order-review' ).loaded();
			$( '#order-review' ).remove();

			$container.prepend( response.table_html );
			
			cart.update();

			_update_quantities_events();
		}
	};

	$( document ).ready( _init );

	return {};

}) ( jQuery );

module.exports = checkout;
},{}],4:[function(require,module,exports){
var fade_in = ( function( $ ) {

	var controller = null;

	var _init = function() {
		controller = new ScrollMagic.Controller();

		add_handlers( $( '.fade-in' ) );
	};

	var add_handlers = function( $object ) {
		$object.each( function() {

			if ( $( this ).hasClass( 'fade-in' ) ) {
				var object = $( this ).get(0);

				new ScrollMagic.Scene( {
					triggerElement: object,
					reverse: false,
					triggerHook: 0.9
				} ).on('start', function () {
					_start_fade_in(object)
				} ).addTo(controller);
			}
		} );
	};

	var _start_fade_in = function( object ) {
		$( object ).addClass( 'done' );
	};

	$( document ).ready( _init );

	return {
		add_handlers: add_handlers
	};
	
} ) ( jQuery );

module.exports = fade_in;
},{}],5:[function(require,module,exports){
var utils = require('./utils');

var hero = ( function( $ ) {

	var slide_speed = 500;

	var $heros = $( '#fp-hero-group .owl-carousel' );

	var _init = function() {
		if ( ! $heros.length > 0 ) {
			return;
		}

		$heros.each( function( index, item ) {
			_setup_slider( $( item ) );
		} );
	};

	var _setup_slider = function( $slider ) {
		$slider.on( 'initialized.owl.carousel', function( event ) {
			_slider_initialised( event, $slider )
		} );

		$slider.owlCarousel( {
			items : 1,
			nav: true,
			navText: [
				'<span class="arrow"></span>',
				'<span class="arrow"></span>'
			],
			dots: false
		} );
	};

	var _slider_initialised = function( event, $slider ) {
		$slider.find( '.owl-item .slide' ).addClass( 'initialised' );
	};

	$( document ).ready( _init );

	return {};

} )( jQuery );

module.exports = hero;
},{"./utils":22}],6:[function(require,module,exports){
var utils = require('./utils');

var gallery_popup = (function( $ ) {

	var $gallery;
	var added  = false;

	var _init = function() {
		$gallery = $( '#gallery' ).find( '.owl-carousel' );

		if ( utils.viewport_size().width >= 992 ) {
			_setup_popup();
		} else {
			$gallery.find( '.zoom-image' ).on( 'click', _prevent_default );
		}
	};

	var _prevent_default = function ( e ) {
		e.preventDefault();
	};

	var _setup_popup = function() {
		$gallery.magnificPopup({
			delegate: 'a',
			closeOnBgClick: false,
			type: 'image',
			midClick: true,
			mainClass: 'gallery-popup',
			closeMarkup: '',
			gallery: {
				enabled: true,
				navigateByImgClick: false,
				preload: [0,1],
				arrowMarkup: '<img title="%title%" src="' + ScriptData.theme_uri + '/resources/images/icons/arrow-%dir%-grey.svg" class="mfp-arrow mfp-arrow-%dir%" />',
				tCounter: ''
			},
			image: {
				tError: '<a href="%url%">The image</a> could not be loaded.'
			},
			callbacks: {
				change: function() {
					if ( this.isOpen ) {
						this.wrap.addClass( 'mfp-open' );
						_change_zoom_image( this.currItem.src, this );
					}
				},
				open: function() {
					_add_buttons();

					_setup_zoom_image();

					$( 'a.fullscreen-button' ).on( 'click', _toggle_fullscreen );
				},

				close: function( ) {
					_close_fullscreen();
				}
			}
		});
	};

	var _add_buttons = function () {
		var $modal      = $( '.mfp-gallery.gallery-popup' ),
			$fullscreen = '<a href="#" title="Toggle Full Screen" class="fullscreen-button"></a>',
			$close      = '<a href="#" title="Close (esc)" style="z-index: 9999" class="close-button mfp-close"></a>';

		if ( ! added ) {
			$modal.append( $fullscreen );
			$modal.append( $close );
			added = true
		}
	};

	var _close_fullscreen = function() {
		var $elem = document.body;

		if ( $elem.exitFullscreen ) {
			$elem.exitFullscreen();
		} else if ( $elem.msExitFullscreen ) {
			$elem.msExitFullscreen();
		} else if ( document.mozCancelFullScreen ) {
			document.mozCancelFullScreen();
		} else if ( document.webkitExitFullscreen ) {
			document.webkitExitFullscreen();
		}
	};

	var _toggle_fullscreen = function( e ) {
		if ( e ) {
			e.preventDefault();
		}

		if( (document.fullScreenElement && document.fullScreenElement !== null) || (!document.mozFullScreen && !document.webkitIsFullScreen) ) {
			if ( document.documentElement.requestFullScreen ) {
				document.documentElement.requestFullScreen();
			} else if ( document.documentElement.mozRequestFullScreen ) {
				document.documentElement.mozRequestFullScreen();
			} else if ( document.documentElement.webkitRequestFullScreen ) {
				document.documentElement.webkitRequestFullScreen( Element.ALLOW_KEYBOARD_INPUT );
			}
		} else {
			if ( document.cancelFullScreen ) {
				document.cancelFullScreen();
			} else if ( document.mozCancelFullScreen ) {
				document.mozCancelFullScreen();
			} else if ( document.webkitCancelFullScreen ) {
				document.webkitCancelFullScreen();
			}
		}
	};

	var _setup_zoom_image = function() {
		var $modal           = $( '.mfp-gallery.gallery-popup' ),
			$image_container = $modal.find( 'figure' ),
			$image_url       = $image_container.find( 'img' ).attr( 'src' );

		$image_container.on( 'click', function( e ) {
			$( this ).toggleClass( 'image-zoom' );
			$modal.find( '.close-button.mfp-close' ).toggleClass( 'white' );
			$modal.find( '.fullscreen-button' ).toggleClass( 'white' );
		} );

		$image_container.append('<div class="zoom-image" style="background-image: url( '+ $image_url + ' )"></div>');

		_setup_zoom_events( $image_container );

		setTimeout( function () {
			$image_container.addClass( 'zoom-ready' );
		}, 400 );
	};

	var _change_zoom_image = function( image_url, gallery ) {
		$( gallery.content ).find( 'figure' ).removeClass( 'image-zoom' );
		$( gallery.content ).find( '.zoom-image' ).css( 'background-image', 'url( '+ image_url + ' )' );
	};

	var _setup_zoom_events = function( $image_container ) {
		var $image = $image_container.find( '.zoom-image' );

		if ( utils.viewport_size().width >= 992 ) {
			$image_container.on( 'mouseover', function( e ) {
				if ( $image_container.hasClass( 'image-zoom' )  ) {
					_zoom_image( 1.7, $image );
					_change_zoom_origin( e, $image, $image_container );
				}
			} );

			$image_container.on( 'mousemove', function( e ) {
				if ( $image_container.hasClass( 'image-zoom' ) ) {
					_change_zoom_origin( e, $image, $image_container );
				}
			} );
		}
	};

	var _zoom_image = function ( scale, $image ) {
		$image.css( { 'transform': 'scale('+ scale +')' } );
	};

	var _change_zoom_origin = function( e, $image, $image_container ) {
		var origin_X = ( e.pageX - $image_container.offset().left ) / $image_container.width() * 100 + '%',
			origin_Y = ( e.pageY - $image_container.offset().top ) / $image_container.height() * 100 + '%';

		$image.css( { 'transform-origin': ( origin_X ) + ( origin_Y ) } );
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = gallery_popup;
},{"./utils":22}],7:[function(require,module,exports){
var gallery = ( function( $ ) {

	var $gallery,
		$carousel,
		$thumbnails;

	var _init = function() {
		$gallery    = $( '#gallery' );
		$carousel   = $gallery.find( '.owl-carousel' );
		$thumbnails = $gallery.find( '.product-gallery-thumbnails .thumbnail-wrapper' );

		_setup_carousel();
	};

	var _setup_carousel = function() {
		$carousel.owlCarousel( {
			items: 1,
			dots: false,
			nav: true,
			navText: [
				'<img src="' + ScriptData.theme_uri + '/resources/images/icons/arrow-left-white.svg" />',
				'<img src="' + ScriptData.theme_uri + '/resources/images/icons/arrow-right-white.svg" />'
			]
		});

		$thumbnails.on( 'click', _thumbnail_clicked );
	};

	var _thumbnail_clicked = function() {
		var index = $( this ).data( 'index' );
		$carousel.trigger( 'to.owl.carousel', [ index, 300, true ] )
	};

	if ( $( '#gallery' ).length > 0 ) {
		$( document ).ready( _init );
	}

} )( jQuery );

module.exports = gallery;
},{}],8:[function(require,module,exports){
var header = ( function( $ ) {

	var $header,
		$hero;

	var _init = function() {
		$header = $( '#header' );
		$hero   = $( '#hero' );

		if ( $hero.length === 0 ) {
			$hero = $( '#manufacturer-slider' );
		}

		$( window ).on( 'scroll', _toggle_fixed_class );

		_toggle_fixed_class();
	};

	var _toggle_fixed_class = function() {
		var $scroll = $( window ).scrollTop(),
			offset  = 0;

		if ( $hero.length > 0 ) {
			offset = $hero.outerHeight();

			if ( $scroll <= offset && $header.hasClass( 'fixed' ) ) {
				$header.removeClass( 'fixed' );
			}
		}

		if ( $scroll > offset && !$header.hasClass( 'fixed' ) ) {
			$header.addClass( 'fixed' );
		} else if ( offset === $scroll && $header.hasClass( 'fixed' ) ) {
			$header.removeClass( 'fixed' );
		}
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = header;
},{}],9:[function(require,module,exports){
var utils = require('./utils');

var hero = ( function( $ ) {

	var $site_wrapper = false;
	var ran_once = false;

    var _init = function() {
		$site_wrapper = $( '#site-wrapper' );

		$( '#scroll' ).find( 'a' ).on( 'click', _scroll_icon_click );

		// $site_wrapper.on( 'scroll', _parallax_fix );
		// $(window).on( 'load', _parallax_fix_new );

		_mobile_image_change();
    };

	var _parallax_fix_new = function() {
		console.log('Loaded. Refreshing parallax');

		$( window ).trigger( 'resize' ).trigger( 'scroll' );
	};

    var _parallax_fix = function() {
		// This is a workaround fix for parallax heros, where a user scrolls before it has fully loaded.
		var top = $( '.parallax-mirror' ).css( 'top' );

		if ( top != '0px' ) {
			$( '.parallax-mirror, .parallax-slider' ).css( 'top', 0 );
			$( window ).trigger( 'resize' ).trigger( 'scroll' );
		}
	};

    var _mobile_image_change = function() {
		var screen_width = utils.viewport_size().width;
		var $hero = $( '#hero' );
		var images = $hero.data( 'images' );

		if ( images ) {
			if ( screen_width < 768 ) {
				$hero.data( 'image-src', images.mobile );
			} else {
				$hero.data( 'image-src', images.large );
			}
		}
	};

    var _scroll_icon_click = function( event ) {
		event.preventDefault();

		var elem = $( this ).attr( 'href' );
		var offset = $( elem ).offset().top;
		offset += $site_wrapper.scrollTop();

		$site_wrapper.animate({
			scrollTop: offset
		}, 500 );
    };

    if ( ! $( 'html body' ).hasClass( '.page-template-front' ) ) {
		$( document ).ready( _init );
	}

	return {};

} )( jQuery );

module.exports = hero;
},{"./utils":22}],10:[function(require,module,exports){
(function( $ ) {

	$.fn.loading = function( loading_img ) {
		if ( typeof loading_img === 'undefined' && typeof ScriptData.ajax_loader_url !== 'undefined' ) {
			loading_img = ScriptData.ajax_loader_url;
		}

		this.fadeTo( '400', '0.5' ).block( {
			message: null, overlayCSS: {
				background: 'transparent url(' + loading_img + ') no-repeat center',
				backgroundSize: '16px 16px',
				opacity: 0.5
			}
		} );

		return this;
	};

	$.fn.loaded = function() {
		this.stop( true ).css( 'opacity', '1' ).unblock();

		return this;
	};

})( jQuery );
},{}],11:[function(require,module,exports){
var main_nav = ( function( $ ) {

	var _init = function() {
		_setup_superfish();
	};

	var _setup_superfish = function() {
		$( '#main-nav .nav' ).superfish({
			delay: 400,
			animation: {
				opacity: 'show',
				height: 'show'
			},
			speed: 'fast',
			autoArrows: false
		});
	};

	$( document ).ready( _init );

	return {};

} )( jQuery );

module.exports = main_nav;
},{}],12:[function(require,module,exports){
var manufacturer_slider = (function( $ ) {

	var $carousel = null;

	var _init = function() {
		$carousel = $( '#manufacturer-slider' ).find( '.carousel' );

		_setup_slider();
	};

	var _setup_slider = function() {

		$carousel.on( 'cycle-initialized', _initialised );

		$carousel.cycle( {
			fx: 'fadeout',
			timeout: 0,
			next: '#manufacturer-slider-next',
			pager: '#manufacturer-slider-pager',
			slides: '> div',
			pagerTemplate: "<div class=\"page\">{{title}}<span class=\"dot\"></span></div>"
		} );

		$carousel.on( 'cycle-after', _after_switch );
	};

	var _initialised = function( event, option_hash ) {
		console.log($carousel.find( '.cycle-slide' ).first());
		_content_fade( $carousel.find( '.cycle-slide' ).first() );
	};

	var _after_switch = function( event, option_hash, outgoing_slide_el, incoming_slide_el, forward_flag ) {
		var $prev_slide = $( outgoing_slide_el );
		var $current_slide = $( incoming_slide_el );

		_content_fade( $current_slide, $prev_slide );
	};

	var _content_fade = function ( $slide, $prev_slide ) {
		$slide.find( '.item-content .slide-fade' ).addClass( 'done' );

		if ( $prev_slide != undefined ) {
			$prev_slide.find( '.item-content .slide-fade' ).removeClass( 'done' );
		}
	};

	if ( $( '#manufacturer-slider' ).length > 0 ) {
		_init();
	}

	return {};

})( jQuery );

module.exports = manufacturer_slider;
},{}],13:[function(require,module,exports){
var model_dropdown = ( function( $ ) {

	var _init = function() {
		_setup_carousel();
	};

	var _setup_carousel = function() {
		$( '.model-dropdown .owl-demo' ).owlCarousel( {
			items: 4,
			dots: false,
			nav: true,
			navText: [
				"<i class='fa fa-angle-left'></i>",
				"<i class='fa fa-angle-right'></i>"
				/*
				"<img src='./resources/images/icons/product-detail-icon1.png' />",
				"<img src='./resources/images/icons/product-detail-icon2.png' />"
				*/
			]
		});

	};

	$( document ).ready( _init );

} )( jQuery );

module.exports = model_dropdown;
},{}],14:[function(require,module,exports){
var notices = ( function() {
	
	var timeout_fade = function( $notices ) {
		$( $notices ).each( function() {
			$( this ).addClass( 'fade' );
			setTimeout( _fade.bind( $( this ) ), 5000 );
		});
	};
	
	var _fade = function() {
		$( this ).addClass( 'fading-out' );
		$( this ).on( 'transitionend webkitTransitionEnd oTransitionEnd', _faded.bind( $( this ) ) );
	};
	
	var _faded = function() {
		$( this ).remove();
	};
	
	return {
		timeout_fade : timeout_fade
	};
	
} ) ( jQuery );

module.exports = notices;
},{}],15:[function(require,module,exports){
var ocm_submenus = ( function( $ ) {

	var $ocm = false;

	var _init = function() {
		$ocm = $( '#off-canvas-menu' );

		$( '#off-canvas-menu .menu-item-has-children > a' ).on( 'click', _parent_click_event );
	};

	var _parent_click_event = function( event ) {
		$menu_item = $( this ).closest( '#off-canvas-menu .menu-item-has-children' );

		$menu_item.toggleClass( 'expanded' );

		event.preventDefault();
	};

	$( document ).ready( _init );

} )( jQuery );

module.exports = ocm_submenus;
},{}],16:[function(require,module,exports){
var utils = require('./utils');

var ocm = ( function( $ ) {

	var viewport = utils.viewport_size();
	var $document = $( document );
	var $html = $( 'html' );
	var $ocm = false;

	var transition_event = 'transition';

	var _init = function() {
		viewport = utils.viewport_size();

		transition_event = utils.which_transition_event();

		$ocm = $( '#off-canvas-menu' );

		$( '.navbar-toggle' ).on( 'click', _ocm_toggle_click_event );
		$ocm.find( '.close' ).on( 'click', _ocm_close_click_event );

		$( window ).on( 'debouncedresize', _smart_resize_event );

		// $( window ).swipe( {
		// 	swipeLeft: _swipe_left_event,
		// 	swipeRight: _swipe_right_event,
		// 	threshold:0,
		// 	fingers:'all'
		// });
	};

	var _swipe_left_event = function( event ) {
		if ( $html.hasClass( 'ocm-right' ) ) {
			open_ocm();
		} else {
			close_ocm();
		}
	};

	var _swipe_right_event = function( event ) {
		if ( $html.hasClass( 'ocm-right' ) ) {
			close_ocm();
		} else {
			open_ocm();
		}
	};

	var _smart_resize_event = function( event ) {
		viewport = utils.viewport_size();

		if ( viewport.width >= 768 ) {
			$html.removeClass( 'ocm-open' );
		}
	};

	var _ocm_close_click_event = function( event ) {
		close_ocm();

		return false;
	};

	var _ocm_toggle_click_event = function( event ) {
		if ( $html.hasClass( 'ocm-open' ) ) {
			close_ocm();
		} else {
			open_ocm();
		}

		return false;
	};

	var open_ocm = function() {
		setTimeout( _start_open_ocm, 25 );
	};

	var _start_open_ocm = function() {
		$html.addClass( 'ocm-open' );
		$document.on( 'click', _body_click_event );
	};

	var close_ocm = function() {
		setTimeout( _start_close_ocm, 25 );
	};

	var _start_close_ocm = function() {
		$document.off( 'click', _body_click_event );

		$ocm.on( transition_event , _ocm_closed_event );

		$html.addClass( 'ocm-closing' );
		$html.removeClass( 'ocm-open' );
	};

	var _ocm_closed_event = function( event ) {
		$html.removeClass( 'ocm-closing' );

		$( this ).off( event );
	};

	var _body_click_event = function( event ) {
		if ( $( event.target ).closest( '#off-canvas-menu' ).length == 0 ) {
			close_ocm();
		}
	};

	$( document ).ready( _init );

} )( jQuery );

module.exports = ocm;
},{"./utils":22}],17:[function(require,module,exports){
var our_collections = ( function ( $ ) {

	var _init = function() {

		var controller = new ScrollMagic.Controller();

		$( '.from-left, .from-right' ).each( function() {

			var object = $( this ).get( 0 );

			new ScrollMagic.Scene({
				triggerElement: object,
				reverse: false,
				triggerHook: 0.75
			} ).on( 'start', function() { _scroll_hit( object ) } )
				.addTo( controller );

		});

		_mobile_carousel();
	};

	var _mobile_carousel = function() {
		$( '#collection-carousel .carousel' ).owlCarousel( {
			items : 1,
			nav: false,
			dots: false
		});
	};

	var _scroll_hit = function( object ) {
		$( object ).addClass( 'active' );
	};

	$( document ).ready( _init );

} ) ( jQuery );

module.exports = our_collections;
},{}],18:[function(require,module,exports){
var product_thumbnail_slider = ( function ( $ ) {

	var $carousel;

	var _init = function() {
		$carousel = $( '.product-gallery-thumbnails .carousel' );

		_setup_slider();
	};

	var _setup_slider = function() {
		$carousel.cycle( {
			fx: 'carousel',
			timeout: 0,
			next: '#thumbnail-next',
			prev: '#thumbnail-prev',
			slides: '> div',
			allowWrap: false
		} );
	};

	if ( $( '.product-gallery-thumbnails' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

})( jQuery );

module.exports = product_thumbnail_slider;
},{}],19:[function(require,module,exports){
var scroll_load = ( function ( $ ) {

	// Pages to load in advance, before the user scrolls to them
	var PAGES_AHEAD = 2;
	// Number of pages that have already been loaded by the initial request
	var PAGES_PRE_LOADED = 1;
	// Container of pages
	var PAGES_CONTAINER = '#blog-posts .row';

	var pages_loaded = PAGES_PRE_LOADED;
	var pages_loading = false;
	var enabled = true;
	var $pages_container = null;
	var scroll_points = [];

	var _add_to_queue = function( value ) {
		scroll_points.push( value );
	};

	var _pop_queue = function() {
		scroll_points.shift();
	};

	var _process_new_page = function( $page ) {
		_insert_page( $page );
		pages_loaded++;
		pages_loading = false;
		$pages_container.next( '.ajax-loader' ).html( '' );

		if ( scroll_points.length > PAGES_AHEAD ) {
			_pop_queue();
		}

		_add_to_queue( $pages_container.height() );
	};

	var _init = function() {
		$pages_container = $( PAGES_CONTAINER );
		_add_to_queue( $pages_container.height() );
		_check_next_page();
	};

	var _get_next_page = function() {

		var data = {
			action: 'get_posts',
			scroll_load_nonce: ScriptData.scroll_load_nonce,
			query_vars: ScriptData.query_vars,
			page: pages_loaded + 1
		};

		$pages_container.next( '.ajax-loader' ).html(
			'<img src="' + ScriptData.ajax_loader_url + '" alt="ajax-loader" /><p>Loading more</p>'
		);

		$.post( ScriptData.ajaxurl, data, _received_page );
//		$pages_container.loading();
		pages_loading = true;
	};

	var _received_page = function( response ) {
		console.log( response );
		if ( response.html ) {
			var $page = $( $.parseHTML( response.html ) );
			_process_new_page( $page );

			$( document ).trigger( 'pageloaded', [$page] );
			_check_next_page();
		} else {
			enabled = false;

			$pages_container.next( '.ajax-loader' ).html( '' );
		}
	};

	var _insert_page = function( html ) {
		$pages_container.append( html );
//		$pages_container.loaded();
	};

	var _check_next_page = function() {
		if ( enabled && ! pages_loading ) {
			var get_next_page = false;

			var distance_from_bottom = scroll_points[0] - window.scrollY + $pages_container.offset().top - $( window ).height();
			if ( distance_from_bottom < 0 ) {
				get_next_page = true;
			}

			if ( scroll_points.length <= PAGES_AHEAD ) {
				get_next_page = true;
			}

			if ( get_next_page ) {
				_get_next_page();
			}
		}
	};

	if ( $( '#blog-posts' ).length > 0 ) {
		$( document ).on( 'ready', _init );
		$( '#site-wrapper' ).scroll( _check_next_page );
	}

	return {};

} ) ( jQuery );

module.exports = scroll_load;
},{}],20:[function(require,module,exports){
var smooth_scroll = ( function( $ ) {
	
	var scroll = function ( target ) {
		
		var offset = $( target ).offset().top;
		offset += $( '#site-wrapper' ).scrollTop();

		$( '#site-wrapper' ).animate({
			scrollTop: offset
		}, 500);
	};
	
	return {
		scroll: scroll	
	};
} ) ( jQuery );

module.exports = smooth_scroll;
},{}],21:[function(require,module,exports){
var specification = ( function ( $ ) {
    var _init = function() {
        _setup_tab_selections();
    };

    var _setup_tab_selections = function() {
		
        $( '.tab-click-redirect' ).click( function( event ) {
            var target = $( this ).attr( 'href' );
			_select_tab( target );
            event.preventDefault();
        });
		
		$( '.scroll-select' ).on( 'click', function( event ) {
			var target = $( this ).attr( 'href' );
			_scroll_select_tab( target );
			event.preventDefault();
		} );
    };
	
	var _select_tab = function( target ) {
		$( '#tabs .nav.nav-tabs a[href="' + target + '"]' ).trigger( 'click' );
	};
	
	var _scroll_select_tab = function( target ) {
		smooth_scroll.scroll( '#tabs' );
		_select_tab( target );
	};

    $( document ).ready( _init );
	
	return {};
	
})( jQuery );

module.exports = specification;
},{}],22:[function(require,module,exports){
var utils = (function( $ ) {

	/*
	 * Returns the viewport size, including scrollbars - which matches media queries
	 *
	 * http://andylangton.co.uk/blog/development/get-viewport-size-width-and-height-javascript
	 */
	var viewport_size = function() {
		var e = window, a = 'inner';
		if ( !( 'innerWidth' in window ) ) {
			a = 'client';
			e = document.documentElement || document.body;
		}
		return { width: e[a + 'Width'], height: e[a + 'Height'] };
	};

	// Function from David Walsh: http://davidwalsh.name/css-animation-callback
	var which_transition_event = function() {
		var t, el = document.createElement( "fakeelement" );

		var transitions = {
			"transition": "transitionend",
			"OTransition": "oTransitionEnd",
			"MozTransition": "transitionend",
			"WebkitTransition": "webkitTransitionEnd"
		};

		for ( t in transitions ) {
			if ( el.style[t] !== undefined ) {
				return transitions[t];
			}
		}
	};

	return {
		viewport_size: viewport_size,
		which_transition_event: which_transition_event
	};

})( jQuery );

module.exports = utils;
},{}],23:[function(require,module,exports){
require('./js/blog.js');require('./js/cart.js');require('./js/checkout.js');require('./js/fade-in.js');require('./js/fp-slider.js');require('./js/gallery-popup.js');require('./js/gallery.js');require('./js/header.js');require('./js/hero.js');require('./js/loading.js');require('./js/main-nav.js');require('./js/manufacturer-slider.js');require('./js/model-dropdown.js');require('./js/notices.js');require('./js/ocm-submenus.js');require('./js/ocm.js');require('./js/our-collections.js');require('./js/product-thumbnails-slider.js');require('./js/scroll_load.js');require('./js/smooth-scroll.js');require('./js/specification.js');require('./js/utils.js');
},{"./js/blog.js":1,"./js/cart.js":2,"./js/checkout.js":3,"./js/fade-in.js":4,"./js/fp-slider.js":5,"./js/gallery-popup.js":6,"./js/gallery.js":7,"./js/header.js":8,"./js/hero.js":9,"./js/loading.js":10,"./js/main-nav.js":11,"./js/manufacturer-slider.js":12,"./js/model-dropdown.js":13,"./js/notices.js":14,"./js/ocm-submenus.js":15,"./js/ocm.js":16,"./js/our-collections.js":17,"./js/product-thumbnails-slider.js":18,"./js/scroll_load.js":19,"./js/smooth-scroll.js":20,"./js/specification.js":21,"./js/utils.js":22}]},{},[23]);
